angular
  .module('directives.spinner', [])
  .directive('spinner', [
    'SpinnerService',
    function(Spinner) {
      var link = function ($scope) {
        $scope.hideSpinner = Spinner.allFlagsMarked;
      };

      return {
        restrict: 'E',
        template:
          '<div ng-hide="hideSpinner()" class="spinner-layer" ng-click="$event.stopPropagation()">' +
            '<div class="loading-overlay"></div>' +
          '</div>',
        scope: {},
        link: link
      };
    }
  ]);
